/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Помощь с технической поддержкой
 * @export
 * @enum {string}
 */
export enum HelpType {
  ModuleTechSupport = 'moduleTechSupport',
  ModuleCallRequest = 'moduleCallRequest',
  ModuleAffiliateProgram = 'moduleAffiliateProgram',
  ModuleMonitoring = 'moduleMonitoring',
  ModuleDisposalOfTheRights = 'moduleDisposalOfTheRights',
  ModuleExtensionOfRights = 'moduleExtensionOfRights',
  ModuleRegistryEdit = 'moduleRegistryEdit',
  ModuleRegistryExtend = 'moduleRegistryExtend',
  ModuleRegistryDuplicate = 'moduleRegistryDuplicate',
  ModuleRegistryDisposalOfTheRights = 'moduleRegistryDisposalOfTheRights',
  ModuleHelpWithApplication = 'moduleHelpWithApplication',
  ModuleHelpWithRegistry = 'moduleHelpWithRegistry',
  ModuleHelpWithSearch = 'moduleHelpWithSearch',
  ModuleHelpWithApplicationDocuments = 'moduleHelpWithApplicationDocuments',
  ModuleHelpWithRegistryApplication = 'moduleHelpWithRegistryApplication',
  ModuleHelpWithInstruction = 'moduleHelpWithInstruction',
}

export function instanceOfHelpType(value: any): boolean {
  for (const key in HelpType) {
    if (Object.prototype.hasOwnProperty.call(HelpType, key)) {
      if (HelpType[key as keyof typeof HelpType] === value) {
        return true
      }
    }
  }
  return false
}

export function HelpTypeFromJSON(json: any): HelpType {
  return HelpTypeFromJSONTyped(json, false)
}

export function HelpTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HelpType {
  return json as HelpType
}

export function HelpTypeToJSON(value?: HelpType | null): any {
  return value as any
}
